import React, { MouseEvent } from 'react'
import styled from 'styled-components'

import {
	DialogTitle as MDialogTitle,
	DialogTitleProps,
	IconButton,
} from '@mui/material'

import { pxToRem } from '../../libs/style'
import CloseIcon from '../icons/CloseIcon'
import theme from '../theme'
import FirstLetterCapital from '../typography/FirstLetterCapital'

const StyledDialogTitle = styled(MDialogTitle)`
	background-color: ${theme.palette.background.secondary};
	color: ${theme.palette.grey[700]};
	font-size: ${pxToRem(24)}rem;
	font-family: 'Poppins';
	display: flex;
	justify-content: space-between;
	align-items: center;
`

const OutlinedButton = styled(IconButton)`
	border: solid 1px ${theme.palette.grey[700]};
	border-radius: 50%;
	background-color: ${theme.palette.common.white};
	color: ${theme.palette.grey[700]};
`

const ContainedButton = styled(IconButton)`
	color: ${theme.palette.common.white};
	padding: 0;
`

interface Props extends DialogTitleProps {
	closeButtonVariant?: 'outlined' | 'contained'
	onClose?: (event: MouseEvent) => void
}

const DialogTitle = ({
	onClose,
	closeButtonVariant = 'contained',
	children,
	...props
}: Props) => {
	const CloseButton =
		closeButtonVariant === 'contained' ? ContainedButton : OutlinedButton
	return (
		<StyledDialogTitle {...props}>
			<FirstLetterCapital>{children}</FirstLetterCapital>
			{onClose ? (
				<CloseButton aria-label="close" onClick={onClose}>
					<CloseIcon />
				</CloseButton>
			) : null}
		</StyledDialogTitle>
	)
}
export default DialogTitle
